<div class="root-container">
  <customer-header />
  <div class="content scrollbars" #scrollContainer>
    <div class="main">
      <router-outlet />
    </div>
    <public-footer />
  </div>
  <modals #modals />
  <toast #toasts></toast>
  <login-modal #login_modal />
  <scroll-to-top #scrollTop [scrollContainerRef]="scrollContainer" />
</div>
